import React, { useContext } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { ExternalLink } from "components/common";
import FormDataContext from "integrations/contexts/FormDataContext";
import { AdvancedOptionsContext } from "integrations/aws/context/AdvancedOptions";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import ValidatedInput from "integrations/aws/common/ValidatedInput";
import { SectionTitle, SectionNote } from "integrations/aws/common/sharedStyles";
import useProductName from "brand-customization/useProductName";
const INPUT_PATTERN = "https://(.*)";
const INPUT_PLACEHOLDER = "https://vpce-1234.service.region.vpce.amazonaws.com";
const StyledSectionTitle = styled(SectionTitle)`
  margin: 12px 0 0;
`;
const StyledSectionNote = styled(SectionNote)`
  margin: 0 0 12px;
`;
const AWSCustomEndpoints = ({ onChange }) => {
  const { t } = useTranslation("integrations");
  const { formData } = useContext(FormDataContext);
  const productName = useProductName();
  const { isAWSCustomEndpointsVisible, setAWSCustomEndpointsVisibility } = useContext(AdvancedOptionsContext);
  const { awsEndpointCloudWatch, awsEndpointDynamoDB, awsEndpointIAM, awsEndpointKinesis } = formData;
  const handleToggle = (visible) => {
    setAWSCustomEndpointsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("aws_custom_endpoints.title"),
      visible: isAWSCustomEndpointsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(StyledSectionTitle, null, t("aws_custom_endpoints.section_title", { productName })),
    /* @__PURE__ */ React.createElement(StyledSectionNote, null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "aws_custom_endpoints.note",
        components: {
          vpcEndpointsLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://docs.aws.amazon.com/vpc/latest/userguide/vpc-endpoints.html" })
        }
      }
    )),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsEndpointCloudWatch",
        type: "text",
        fieldData: awsEndpointCloudWatch,
        onChange,
        label: t("aws_custom_endpoints.cloudwatch_label"),
        placeholder: INPUT_PLACEHOLDER,
        pattern: INPUT_PATTERN,
        title: t("aws_custom_endpoints.input_message")
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsEndpointIAM",
        type: "text",
        fieldData: awsEndpointIAM,
        onChange,
        label: t("aws_custom_endpoints.iam_label"),
        placeholder: INPUT_PLACEHOLDER,
        pattern: INPUT_PATTERN,
        title: t("aws_custom_endpoints.input_message")
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsEndpointDynamoDB",
        type: "text",
        fieldData: awsEndpointDynamoDB,
        onChange,
        label: t("aws_custom_endpoints.dynamodb_label"),
        placeholder: INPUT_PLACEHOLDER,
        pattern: INPUT_PATTERN,
        title: t("aws_custom_endpoints.input_message")
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        id: "awsEndpointKinesis",
        type: "text",
        fieldData: awsEndpointKinesis,
        onChange,
        label: t("aws_custom_endpoints.kinesis_label"),
        placeholder: INPUT_PLACEHOLDER,
        pattern: INPUT_PATTERN,
        title: t("aws_custom_endpoints.input_message")
      }
    )
  );
};
export default AWSCustomEndpoints;
